/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdministrativeFieldsHistoryRequest } from '../../models/administrative-fields-history-request';
import { AdministrativeFieldsHistoryResponse } from '../../models/administrative-fields-history-response';

export interface PostApiAdministrativeV1IdHistory$Plain$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: AdministrativeFieldsHistoryRequest
}

export function postApiAdministrativeV1IdHistory$Plain(http: HttpClient, rootUrl: string, params: PostApiAdministrativeV1IdHistory$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrativeFieldsHistoryResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiAdministrativeV1IdHistory$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdministrativeFieldsHistoryResponse>;
    })
  );
}

postApiAdministrativeV1IdHistory$Plain.PATH = '/private/v1/companies/{id}/history';
